const closeDelay = 250;
let initialized = false;

export function initNavbar() {
  if (initialized) return;

  initialized = true;

  initDropdowns();
  initScrolledState();
}

function initDropdowns() {
  const wrappers = document.querySelectorAll(".navbar__link-dropdown--wrapper");

  wrappers.forEach(function(wrapper) {
    const dropdown = wrapper.querySelector(".navbar__link-dropdown");
    let closeTimer;

    if (!dropdown) return;

    const openDropdown = function() {
      clearTimeout(closeTimer);
      wrapper.classList.add("open");
      dropdown.classList.add("open");
    };

    const closeDropdown = function() {
      clearTimeout(closeTimer);
      wrapper.classList.remove("open");
      dropdown.classList.remove("open");
    };

    const scheduleClose = function() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function() {
        closeDropdown();
      }, closeDelay);
    };

    wrapper.addEventListener("mouseenter", openDropdown);
    dropdown.addEventListener("mouseenter", openDropdown);
    wrapper.addEventListener("mouseleave", scheduleClose);
    dropdown.addEventListener("mouseleave", scheduleClose);
  });
}

function initScrolledState() {
  const navs = document.querySelectorAll(".navbar, .w-nav, nav");

  if (navs.length === 0) return;

  const updateScrolledState = function() {
    navs.forEach(function(nav) {
      nav.classList.toggle("scrolled", window.scrollY > 0);
    });
  };

  updateScrolledState();
  window.addEventListener("scroll", updateScrolledState, { passive: true });
}
